module.exports = __webpack_public_path__ + "static/village_card_img1@2x-3bf3f840bf7fc928cedf7ce887875a4d.png";